<script>
  import Bleed from "$lib/components/Bleed.svelte";
  import Pagination, { paginateItems } from "$lib/components/Pagination/Pagination.svelte";
  import YoutubeEmbed from "$lib/contentTypes/Embed/YoutubeEmbed.svelte";
  import { elementIsFullyInViewport, textToId } from "$lib/utilities/dom-helpers";
  import YoutubeEmbedDescription from "$lib/contentTypes/Embed/YoutubeEmbedDescription.svelte";

  export let videos;

  let activePage = 0;
  export let itemsPerPage = 3;
  let videoPlaylistMainView;

  function getYoutubeThumbnailUrl(url) {
    let videoId =
      url.split("https://youtu.be/")?.[1] /* short url */ ||
      url.split("https://www.youtube.com/watch?v=")?.[1] /* legacy long url */ ||
      url.split("https://www.youtube.com/embed/")?.[1]; /* new long url */

    return `https://i3.ytimg.com/vi/${videoId}/hqdefault.jpg`;
  }

  let activeVideoIndex = 0;

  function changeVideo(videoIndex) {
    return () => {
      activeVideoIndex = videoIndex + activePage * itemsPerPage;
      if (videoPlaylistMainView && !elementIsFullyInViewport(videoPlaylistMainView)) {
        videoPlaylistMainView.scrollIntoView({ behavior: "smooth" });
      }
    };
  }

  function onNavigate(event) {
    activePage = event.detail.page - 1;
    activeItems = paginatedItems[activePage];
  }

  $: ({ numOfPages, paginatedItems } = paginateItems(videos, itemsPerPage));
  $: activeItems = paginatedItems?.[0] ?? [];
  $: focusedItem = videos[activeVideoIndex];
</script>

<Bleed fullWidth contentClasses="px-24 lg:px-72" class="embedded-content">
  <div class="grid lg:grid-cols-5 gap-y-24 lg:gap-y-0 lg:gap-x-48">
    <div class="lg:col-span-3" bind:this={videoPlaylistMainView}>
      <YoutubeEmbed data={focusedItem} />
      <YoutubeEmbedDescription data={focusedItem} class="md:text-size-20 sm:text-size-16 py-32" />
    </div>
    <div class="lg:col-span-2 grid gap-y-24">
      {#each activeItems as video, index}
        <button
          class="flex"
          aria-labelledby={textToId(video.fields.title)}
          aria-current={activeVideoIndex === index}
          on:click={changeVideo(index)}
        >
          <div class="basis-2/5">
            <img
              src={getYoutubeThumbnailUrl(video.fields.url)}
              alt={video.fields.title}
              class="aspect-[4/3]"
            />
          </div>
          <div class="basis-3/5">
            {#if video.fields.title}
              <p
                id={textToId(video.fields.title)}
                class="font-bold text-size-12 lg:text-size-base pl-16"
              >
                {video.fields.title}
              </p>
            {/if}
          </div>
        </button>
      {/each}
      {#if videos.length > 3}
        <Pagination
          numOfItems={videos?.length}
          {numOfPages}
          {itemsPerPage}
          alignLabelCenter={true}
          on:navigate={onNavigate}
          class="w-auto mx-auto py-24"
        />
      {/if}
    </div>
  </div>
</Bleed>
